var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { TPAComponentsConsumer } from '../../TPAComponentsConfig';
import { st, classes } from './ActionsMenuLayoutItem.st.css';
import { Text } from '../../Text';
import { ACTIONS_MENU_ITEM_DATA_HOOK } from '../dataHooks';
import { isSelectKey } from '../../../common/keyCodes';
/** ActionsMenuLayout */
var ActionsMenuLayoutItem = /** @class */ (function (_super) {
    __extends(ActionsMenuLayoutItem, _super);
    function ActionsMenuLayoutItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.liRef = React.createRef();
        _this._onKeyDown = function (e) {
            if (!_this.props.disabled && isSelectKey(e)) {
                e.preventDefault();
                _this.props.onClick();
            }
        };
        return _this;
    }
    ActionsMenuLayoutItem.prototype.focus = function () {
        if (this.liRef.current) {
            this.liRef.current.focus();
        }
    };
    ActionsMenuLayoutItem.prototype.render = function () {
        var _this = this;
        var _a = this.props, content = _a.content, prefixIcon = _a.prefixIcon, subtitle = _a.subtitle, disabled = _a.disabled, onClick = _a.onClick, alignment = _a.alignment, className = _a.className;
        return (React.createElement(TPAComponentsConsumer, null, function (_a) {
            var mobile = _a.mobile, rtl = _a.rtl;
            return (React.createElement("li", { onKeyDown: _this._onKeyDown, "aria-label": _this.props['aria-label'], tabIndex: -1, ref: _this.liRef, key: content, className: st(classes.root, { mobile: mobile, rtl: rtl, disabled: disabled, alignment: alignment, withIcon: !!prefixIcon }, className), role: "menuitem", "aria-disabled": disabled, "data-hook": ACTIONS_MENU_ITEM_DATA_HOOK, "data-content": content, onClick: disabled ? undefined : onClick },
                React.createElement("div", { className: classes.container },
                    prefixIcon ? (React.createElement("div", { className: classes.iconContainer },
                        React.createElement("div", { className: classes.icon }, prefixIcon))) : null,
                    React.createElement("div", { className: classes.textContainer },
                        React.createElement("div", { className: classes.text },
                            React.createElement(Text, { className: classes.content }, content),
                            subtitle && (React.createElement(Text, { className: classes.subtitle }, subtitle)))))));
        }));
    };
    ActionsMenuLayoutItem.displayName = 'ActionsMenuLayout.Item';
    return ActionsMenuLayoutItem;
}(React.Component));
export { ActionsMenuLayoutItem };
//# sourceMappingURL=ActionsMenuLayoutItem.js.map